import ShopDescription from "./ShopDescription";
import ProductCarousel from "./ProductCarousel";

export default function EduRoboShopAd() {
    return (
        <div
            style={{
                height: "100%",
                backgroundColor: "#f0f2f5",
                padding: "2px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "flex-start",
                gap: "10px",
            }}
        >
            <ShopDescription />
            <ProductCarousel />
        </div>
    );
}
